import React from 'react'
import {
    change as changeFieldValue, Field, formValueSelector, reduxForm
} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import cadastrarEmpresa from '../../actions/empresa/cadastrarEmpresas'
import buscarEmpresas from '../../actions/empresa/buscarEmpresas';
import alterarEmpresa from '../../actions/empresa/alterarEmpresas'
import {
    renderFieldCnpj,
    renderFieldEmail,
    renderFieldNumber, renderFieldSelect,
    renderFieldTelefone,
    renderFieldText,
    required, requiredSelect
} from '../../util/inputs';
import {tipoRegimeTributario} from '../../util/constantsUtil';

export const validate = (values) => {
    const erros = {};
    if (!values.nome) {
        erros.nome = 'Campo obrigatório'
    }
    if (!values.email) {
        erros.email = 'Campo obrigatório'
    }
    if (!values.ie) {
        erros.ie = 'Campo obrigatório'
    }
    if (!values.im) {
        erros.im = 'Campo obrigatório'
    }
    if (!values.tar) {
        erros.tar = 'Campo obrigatório'
    }
    if (!values.regimeTributario) {
        erros.regimeTributario = 'Campo obrigatório'
    }
    if (!values.cnae) {
        erros.cnae = 'Campo obrigatório'
    }
    return erros
};


const renderField = ({
                         input,
                         label,
                         type,
                         css,
                         max,
                         readOnly,
                         meta: {touched, error}
                     }) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input {...input} type={type}
                   className={css}
                   maxLength={max}
                   style={{borderColor: touched && error ? 'red' : ''}}
                   id={input.name}
                   disabled={readOnly}
                   readOnly={readOnly}/>
            {touched
            && (error && <span style={{color: 'red'}}>{error}</span>)}
        </div>
    </div>
);

const renderFieldSemLabel = ({
                                 input,
                                 type,
                                 css,
                                 max,
                                 readOnly,
                                 meta: {touched, error}
                             }) => (
    <div>
        <div>
            <input {...input} type={type}
                   className={css}
                   maxLength={max}
                   style={{borderColor: touched && error ? 'red' : ''}}
                   id={input.name}
                   disabled={readOnly}
                   readOnly={readOnly}/>
            {touched
            && (error && <span style={{color: 'red'}}>{error}</span>)}
        </div>
    </div>
);

export class DadosConfiguracaoBPE extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelecionarRegimeTributario = this.handleSelecionarRegimeTributario.bind(this);

        this.state = {
            mensagem: {tipo: '', texto: ''},
            usuario: null,
            tiposQualificacao: [],
        };
    }


    submit(values) {
        if (this.props.idEmpresa) {
            this.props.alterarEmpresa(this.props.montarParametroEmpresa(values)).then((resp) => {
                if (resp.payload.status === 200) {
                    const mensagem = {tipo: 'sucesso', texto: 'Empresa atualizado com sucesso'};
                    this.setState({mensagem, usuario: null});
                    this.props.buscarEmpresas();
                } else {
                    const mensagem = {
                        tipo: 'erro',
                        texto: resp.payload.response.data.mensagens[0].mensagem
                    };

                    this.setState({mensagem});
                }
            }).catch((error) => {
                const mensagem = {
                    tipo: 'erro',
                    texto: error.response.data.message ? error.response.data.message : error.response.statusText
                };
                this.setState({mensagem, usuario: null});
            })
        } else {
            this.props.cadastrarEmpresa(this.props.montarParametroEmpresa(values)).then((resp) => {
                if (resp.payload.status === 200) {
                    this.props.reset('formCadastrarConfiguracaoBPe');
                    const mensagem = {tipo: 'sucesso', texto: 'Empresa cadastrada com sucesso'};
                    this.setState({mensagem, usuario: null});
                    this.props.buscarEmpresas();
                } else {
                    const mensagem = {
                        tipo: 'erro',
                        texto: resp.payload.response.data.mensagens[0].mensagem
                    };

                    this.setState({mensagem, usuario: null});
                }
            }).catch((error) => {
                const mensagem = {
                    tipo: 'erro',
                    texto: error.response.data.message ? error.response.data.message : error.response.statusText
                };
                this.setState({mensagem, usuario: null});
            })
        }
    }

    handleSelecionarRegimeTributario(evento) {
        this.props.selecionaregimeTributario(evento);
    }

    handleChange(event) {
        this.limparMensagem();
        const file = event.target.files[0];
        if (/\.(jpe?g|png)$/i.test(file.name) === false) {
            const mensagem = {
                tipo: 'erro',
                texto: 'Formato de imagem inválido. Informe uma imagem nos formatos JPEG ou PNG.'
            };
            this.setState({mensagem});
            return
        }
        this.converterParaBase64(file)
    }

    handleChangeCertificado(event) {
        const file = event.target.files[0];
        this.props.adicionaArquivo(file)
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'nomeCertificado', file.name);
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'certificado', file.name);
    }


    // eslint-disable-next-line class-methods-use-this
    converterParaBase64(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
                'logoMarca', reader.result);
        }.bind(this);
        reader.onerror = function () {
            const mensagem = {
                tipo: 'erro',
                texto: 'Imagem inválida. Selecione outra imagem.'
            };
            this.setState({mensagem});
        }.bind(this);
    }

    limparMensagem() {
        this.setState({mensagem: undefined})
    }

    recuperaMensagem() {
        if (this.state.mensagem !== null && this.state.mensagem !== undefined) {
            if (this.state.mensagem.tipo === 'sucesso') {
                return (
                    <div className="alert alert-success col-md-12">
                        {this.state.mensagem.texto}
                        <button type="button" className="close" aria-label="Close"
                                onClick={() => {
                                    this.limparMensagem();
                                    this.setState({usuario: null})
                                }
                                }>
                            <i className="material-icons">
                                &#xe5cd;
                            </i>
                        </button>
                    </div>
                )
            }
            if (this.state.mensagem.tipo === 'erro') {
                return (
                    <div className="alert alert-danger col-md-12">
                        {this.state.mensagem.texto}
                        <button type="button" className="close" aria-label="Close"
                                onClick={() => {
                                    this.limparMensagem();
                                }
                                }>
                            <i className="material-icons">
                                &#xe5cd;
                            </i>
                        </button>
                    </div>
                )
            }
        }
        return ''
    }

    limparFormulario() {
        this.props.reset('formCadastrarConfiguracaoBPe');
        this.limparMensagem();
    }

    limparCampos() {
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'nome', '');
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'ddd', '');
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'celular', '');
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'email', '');
        this.setState({marcacaoLida: false, usuario: null});
    }

    removerCertificado() {
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'cetificado', null);
    }

    limparInformacoesBPE() {
        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'nomeCertificado', '');

        this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
            'senhaCertificado', '');

        this.props.removeArquivo();

    }

    exibirCamposBPE() {
        if (!this.props.seHabilitadaBPe) {
            return ''
        }
        return (<div>
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6 mt-3">
                        {this.props.nomeCertificado ? <div>
                            <label>Certificado: {this.props.nomeCertificado}
                                <button type="button" className="btn btn-editar ml-2"
                                    title='Remover'
                                    onClick={() => this.limparInformacoesBPE()}>
                                    <i className="material-icons nav-icon" style={{
                                    fontSize: 18,
                                    color: 'red'
                                        }}>&#xe5cd;</i>
                                </button>
                            </label>
                        </div> : ''}
                        <div className='input-wrapper'>
                            <label htmlFor='input-file'>
                                {this.props.nomeCertificado ? 'Alterar certificado' : 'Selecionar certificado'}
                            </label>
                            <input id='input-file' type='file' value=''
                                   accept=".pfx"
                                   onChange={this.handleChangeCertificado.bind(this)}/>
                            <span id='file-name'/>
                        </div>
                    </div>
                    {this.props.certificado
                        ? <div className="col-12 col-sm-6 col-md-3 mt-2">
                            <Field name='senhaCertificado' type="password" component={renderFieldText}
                                   label='Senha do certificado: '
                                   validate={[required]}
                                   css="form-control" readOnly={false}/>
                        </div>
                        : ''
                    }
                </div>
            </div>
        )
    }

    render() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;
        return (
            <div className="modal-body">
                {this.recuperaMensagem()}
                <form onSubmit={handleSubmit}>
                    <div className="form-row">
                        <div className="col-12 col-sm-4 col-md-4">
                            <Field name="cnpj" type="text" component={renderFieldCnpj} label="CNPJ/CPF:"
                                   css="form-control" readOnly={false}/>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-12 col-sm-9 col-md-9">
                            <Field name="razaoSocial" type="text" component={renderField} label="Razão social:"
                                   css="form-control" readOnly={false}/>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-12 col-sm-9 col-md-9">
                            <Field name="nomeFantasia" type="text" component={renderField} label="Nome fantasia:"
                                   css="form-control" readOnly={false}/>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-12 col-sm-6 col-md-6">
                            <Field name="email" type="email" component={renderFieldEmail} label="E-mail:"
                                   css="form-control" readOnly={false}/>
                        </div>
                        <div className="col-12 col-sm-6 col-md-4">
                            <Field name="telefone" type="text" component={renderFieldTelefone}
                                   css="form-control" label="Telefone"/>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-12 col-sm-6 col-md-6">
                            <Field name="ie" type="text" component={renderFieldNumber} formatacao="##############"
                                   validate={[required]}
                                   label="Inscrição Estadual:"
                                   css="form-control" readOnly={false}/>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6">
                            <Field name="im" type="text" component={renderFieldText} formatacao="################"
                                   validate={[required]}
                                   label="Inscrição Municipal:"
                                   css="form-control" readOnly={false}/>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="col-12 col-sm-4 col-md-4">
                            <Field name="tar" type="text" component={renderFieldText}
                                   label="TAR:"
                                   css="form-control" readOnly={false}/>
                        </div>
                        <div className="col-12 col-sm-4 col-md-4">
                            <Field name='regimeTributario'
                                   options={tipoRegimeTributario.map(elemento => ({
                                       descricao: elemento.label,
                                       nome: elemento.value
                                   }))}
                                   placeholder='Selecione...'
                                   onChange={(e) => this.handleSelecionarRegimeTributario(e)}
                                   component={renderFieldSelect}
                                   label='Regime Tributário:' validate={requiredSelect}/>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="col-12 col-sm-4 col-md-4">
                            <Field name="cnae" type="text" component={renderFieldNumber}
                                   formatacao="#######" validate={[required]}
                                   label="CNAE:"
                                   css="form-control" readOnly={false}/>
                        </div>
                        <div className="col-12 col-sm-4 col-md-4">
                            <Field name="numeracao" type="text" component={renderFieldNumber}
                                   formatacao="#########"
                                   label="Numeração:"
                                   css="form-control" readOnly={this.props.codigoEmpresa && !this.props.sePodeAlterarNumeracao}/>
                        </div>
                    </div>
                    {this.exibirCamposBPE()}

                    <div className="form-group area-codigo">
                        <Field name="codigoEmpresa" type="hidden" component={renderFieldSemLabel}
                               css="form-control col-md-12"/>
                        <Field name="codigoConfiguracaoBPe" type="hidden" component={renderFieldSemLabel}
                               css="form-control col-md-12"/>
                        <Field name="nomeCertificado" type="hidden" component={renderFieldSemLabel}
                               css="form-control col-md-12"/>

                        <Field name="certificado" type="hidden" component={renderFieldSemLabel}
                               css="form-control col-md-12"/>

                    </div>

                    <div className="modal-footer mt-2">
                        <button type="submit" disabled={invalid || submitting || pristine}
                                className="btn btn-laranja">Avançar
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        codigoEmpresa: formValueSelector('formCadastrarConfiguracaoBPe')(state, 'codigoEmpresa'),
        nome: formValueSelector('formCadastrarConfiguracaoBPe')(state, 'nome'),
        nomeCertificado: formValueSelector('formCadastrarConfiguracaoBPe')(state, 'nomeCertificado'),
        email: formValueSelector('formCadastrarConfiguracaoBPe')(state, 'email'),
        numeracao: formValueSelector('formCadastrarConfiguracaoBPe')(state, 'numeracao'),
        certificado: formValueSelector('formCadastrarConfiguracaoBPe')(state, 'certificado'),
        sePodeAlterarNumeracao: formValueSelector('formCadastrarConfiguracaoBPe')(state, 'sePodeAlterarNumeracao'),
        regimeTributario: formValueSelector('formCadastrarConfiguracaoBPe')(state, 'regimeTributario')
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarEmpresa,
        buscarEmpresas,
        alterarEmpresa,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formCadastrarConfiguracaoBPe',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate
})(DadosConfiguracaoBPE));
